/**
 * ``platform.*`` event schemas — frontend-emitted variants only.
 *
 * Today the only frontend-source ``platform.*`` event is
 * ``platform.error.surfaced``, fired by ``ObservabilityErrorBoundary``
 * (PR-8). ``platform.module.access_denied`` and
 * ``platform.error.captured`` are backend-emitted (PR-9 / PR-12).
 *
 * Source of truth: ``plans/PLAN_POSTHOG_02_EVENT_CATALOG.md`` §
 * "platform.*". The ``error_message`` field is truncated at the call
 * site (Plan_03 § "Error pipeline" — recommendation 500 chars); the
 * schema accepts any string and trusts the call site to truncate.
 */

import { z } from "zod";

import { BaseEventSchema } from "./base";

export const PlatformErrorSurfacedSchema = BaseEventSchema.extend({
  event_name: z.literal("platform.error.surfaced"),
  screen: z.string(),
  error_message: z.string(),
  error_boundary: z.boolean(),
});

export const platformEvents = [PlatformErrorSurfacedSchema] as const;
